module.exports = __webpack_public_path__ + "img/air-6.aa86d2ad.jpeg";